<template>
    <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
    <v-card>
        <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
              <v-flex xs12>
                <v-btn fab x-small @click="$router.go(-1)">
                  <v-icon>navigate_before</v-icon>
                    
                  </v-btn>
              </v-flex>

              <v-flex xs12 md1 class="mb-2">
                <v-btn 
                    fab 
                    small
                    @click="printTable()"
                    class="ml-8 white--text"
                    color="#2b6993"
                    elevation="4"
                    absolute 
                    right
                    >
                    <v-icon>print</v-icon>
                </v-btn>
                
              </v-flex>

              <v-flex xs12 md1>
                
              </v-flex>

              <v-flex xs12>
                <h3 class="text-center mb-5">Nevada Billing Report</h3>
                <v-divider class="ml-4 mr-4 mb-3"></v-divider>
              </v-flex>

              <v-flex xs12>
                <v-btn 
                    fab 
                    small
                    @click="generate()"
                    class="ml-8 white--text"
                    color="#2b6993"
                    elevation="4"
                    absolute 
                    right
                    >
                    <v-icon>people</v-icon>
                </v-btn>
              </v-flex>
              
              

              <v-flex xs12 class="pa-2">
                  <v-data-table
                    :headers="headers"
                    :items="billings"
                    sort-by="Name"
                    sort-asc
                    class="elevation-1"
                    :loading="isLoading"
                    loading-text="Loading Client Billing"
                    :items-per-page="100"
                  >
                  <template v-slot:item.select="{ item }">
                      <v-btn
                        x-small
                        class="white--text"
                        color="#2b3990"
                        @click="viewBillingReport(item)"
                      >
                        View
                      </v-btn>
                    <v-btn
                        x-small
                        class="white--text"
                        color="#2b3990"
                        @click="downloadBillingReport(item)"
                    >
                      Download
                    </v-btn>
                  </template>
                  </v-data-table>

                  <v-dialog v-model='dialog' max-width="90%">
                    <v-card>
                      <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm  }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-form
                          ref="form"
                          lazy-validation>
                          <v-container>
                            <v-row>
                        


                            
                              

                          </v-row>
                          </v-container>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1"  class="white--text" @click="updateBilling()">Update</v-btn>
                        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
              </v-flex>
          </v-layout>
        </v-card>

        <div id="print">
          <h2 class="text-center ma-3">Nevada Client Billing Report</h2>
          <v-row>
            <v-col cols="4">
              <v-text-field
                  v-model="startDate"
                  label="Start Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
              ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                  v-model="endDate"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                  readonly
              ></v-text-field>
            </v-col>
             <v-col cols="4">
                <v-text-field
                  label="Select a Program"
                  item-text="Name"
                  item-value="Name"
                  v-model="program"
                  clearable
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                  label="Select a Client"
                  item-text="Name"
                  item-value="_id"
                  v-model="ClientID"
                  clearable
                ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="incidents"
                sort-by="Name"
                sort-asc
                class="elevation-1"
                :loading="isLoading"
                loading-text="Loading Incident Reports"
                :items-per-page="-1"
              >
              </v-data-table>
            </v-col>
          </v-row>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

const NevadaIncidentService = require('../../service/nevada-incident.service');

  export default {
    components: {
    },
    data: () => ({
    headers: [
      {
        text: 'Client',
        align: 'start',
        sortable: true,
        value: 'ClientID.Name',
      },
      { text: "Month", value: "Month" },
      { text: "Year", value: "Year" },
      { text: "Billing Amount", value: "Amount" },
      
      { text: "Status", value: "Status" },
      { text: "Action", value: "select" },

      // { text: "Actions", value: "actions", sortable: false },
    ],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    dialog: false,
    editIncident: false,
    newIncident: false,
    msg: false,
    hospital: false,
    lawEnforcement: false,
    medicalCare: false,
    otherHospital: false,
    otherMedical: false,
    otherLaw: false,
    search: "",
    text:"",
    incidents: [],
    units: [],
    users: [],
    staff: "",
    codes: [],
    tempData: [],
    clientID: '',
    userID: localStorage.getItem("userID"),
    unitID: localStorage.getItem('unitID'),
    involved: ["Involved", "Witness"],
    
    titleForm: "New Incident",
    nvIncidentID: "",
    newRegionalCenter: "",
    newProgram: "",
    programs: [],
    newProgramType: "",
    newType: "",
    newDSINumber: "",
    newDateReceived: "",
    newDSORNumber: "",
    newIncidentType: "",
    newIncidentDate: "",
    newIncidentTime: "",
    newProvider: "Redhead Supports",
    newReportDate: "",
    newServiceCoordinator: "",
    newPrimaryPerson: "",
    newInvolvedWitness: "",
    newPersonServed: "",
    newStaff: "",
    newOther: "",
    newPerson2: "",
    newPersonName2: "",
    newInvolvedWitness2: "",
    newPersonServed2: "",
    newStaff2: "",
    newOther2: "",
    newPerson3: "",
    newPersonName3: "",
    newInvolvedWitness3: "",
    newPersonServed3: "",
    newStaff3: "",
    newOther3: "",
    newPerson4: "",
    newPersonName4: "",
    newInvolvedWitness4: "",
    newPersonServed4: "",
    newStaff4: "",
    newOther4: "",
    newPerson5: "",
    newPersonName5: "",
    newInvolvedWitness5: "",
    newPersonServed5: "",
    newStaff5: "",
    newOther5: "",
    newPerson6: "",
    newPersonName6: "",
    newInvolvedWitness6: "",
    newPersonServed6: "",
    newStaff6: "",
    newOther6: "",
    newLiving: [],
    newJDT: "",
    newEventDescription: "",
    newMissingPersonReport: "",
    newInjury: "",
    newInjuryType: "",
    newInjuryDetails: "",
    newInjuryCause: "",
    newInjuryDetails2: "",
    newInjuryPerson: "",
    newInjuryDetails3: "",
    newNurse: "",
    newMedicalTreatment: "",
    newUnplanned: "",
    newHospitalType: [],
    newAggression: "",
    newAggressionType: [],
    newAbuseNeglect: "",
    newAbuseDescription: "",
    newVehicleAccident: "",
    newVehicleType: [],
    newMedical: "",
    newMedicalDetails: "",
    newMedicalType: "",
    newMedError: "",
    newMedErrorType: [],
    newMedOther: "",
    newErrorDate: "",
    newErrorTime: "",
    newPhysicianNotified: "",
    newEffects: "",
    newNursingDetails: "",
    newStaffName: "",
    newMedDate: "",
    newSignatureDate: "",
    newMedDateTime: "",
    newBehavior: "",
    newPropertyDamage: "",
    newDamageOther: "",
    newPolice: "",
    newArrested: "",
    newDamage: "",
    newVictim: "",
    newVictimOther: "",
    newDeath: "",
    newDeathType: "",
    newOtherDescribe: "",
    newASDS: "",
    newFamily: "",
    newGuardian: "",
    newGuardianNotified: "",
    newServiceCoordinatorName: "",
    newPolice911: "",
    newHealthCareQuality: "",
    newAgingServices: "",
    newCPS: "",
    newCoroner: "",
    newShiftSupervisor: "",
    newNurseName: "",
    newAgencyAdmin: "",
    newAgencyOther: "",
    newActionsTaken: "",
    newReportersName: "",
    newReportersSignature: "",
    reportersSignature: false,
    newReportersTitle: "",
    newReportersDate: "",
    newSupervisorSignature: "",
    newSupervisorTitle: "",
    newSupervisorDate: "",
    newGuardianDate: "",
    newSCNotified: "",
    newSCDate: "",
    newCompliance: "",
    newComplianceDate: "",
    newComplianceSignature: "",
    newWellSkyIR: "",
    newStaffSignature: "",
    endDate: "",
    startDate: "",
    person2: false,
    person3: false,
    staffSignature: false,
    supervisorSignature: false,
    managerSignature: false,
    reviewedSignature: false,
    startMenu: false,
    endMenu: false,
    calendarMenu: false,
    calendar2Menu: false,
    calendar3Menu: false,
    calendar4Menu: false,
    calendar5Menu: false,
    calendar6Menu: false,
    calendar7Menu: false,
    calendar8Menu: false,
    calendar9Menu: false,
    calendar10Menu: false,
    requiredField: [
        v => !!v || 'This is required',
    ],
    url: require("../../client_config/config").url,
    states: ["Utah", "Nevada"],
    userState: localStorage.getItem('userState'),
    isLoading: false,
    ClientID: "",
    program: '',
    clients: [],
    readonly: false,
    newJDTOther: '',
    newDocument: '',
    newNotificationSubmitted: '',
    newReportSubmitted: '',
    newOLReportDate: "",
    reportSubmittedDate: "",
    }),

    computed: {
      
    },

    created() {
      this.getClients();
      this.getPrograms();
      this.incidentQuery();
    },

    methods: {
      initialize() {
        this.clients = [];
      },

      async getClients () {
        let params = {};
            let endpoint = `${url}/clients`;

            const companyIds = localStorage.getItem('userCompanies');

            params['Company:in'] = JSON.parse(companyIds);
            params['State'] = this.userState;

            await axios.get(endpoint,{params})
              .then((res) => {
                  this.clients = res.data.clients;
              });  
      },

      async getPrograms () {
        const companyIds = localStorage.getItem('userCompanies');

        await axios.get(`${url}/units/state/${this.userState}`,{
            params: {
                Company: JSON.parse(companyIds)
            }
        })
          .then((res) => {
            this.programs = res.data.units;  
          });      
      },

      generate(){
        axios.post(`${url}/nevadaBilling/generate`).then(res => {
            this.billings = res.data.billings
        })
      },

      close() {
        this.dialog = false;
        this.clearFields();
      },
      
      incidentQuery() {
        this.incidents = [];
        this.isLoading = true;

        this.program = this.program || '';
        this.startDate = this.startDate || '';
        this.endDate = this.endDate || '';
        this.ClientID = this.ClientID || '';

        const companyIds = localStorage.getItem('userCompanies');
        const params = {
          program: this.program,
          startDate: this.startDate,
          endDate: this.endDate,
          clientID: this.ClientID,
          Company: JSON.parse(companyIds)
        }
        
        NevadaIncidentService.get(params)
        .then(response => {
          this.incidents = response.data.nevadaIncidents;
          this.isLoading = false;
        });
      },

      downloadIncidentReport(item) {
        let id = item._id;
        console.log({itemPdf: item});
        window.open(`${url}/nevadaIncidents/download?id=${id}`);
      },

      viewIncidentReport(item) {
        this.titleForm= "Viewing Incident";
        this.dialog = true;
        this.editIncident = true;
        this.newIncident = false;
        this.selectedIncidentReport = item;
        this.nvIncidentID = item._id;
        this.newRegionalCenter = item.RegionalCenter;
        this.newProgram = item.Program;
        this.newProgramType = item.ProgramType;
        this.newType = item.Type;
        this.newDSINumber = item.DSINumber
        this.newDateReceived = item.DateReceived;
        this.newDSORNumber = item.DSORNumber;
        this.newIncidentType = item.IncidentType;
        this.newIncidentDate = item.IncidentDate;
        this.newIncidentTime = item.IncidentTime;
        this.newProvider = item.Provider;
        this.newReportDate = item.ReportDate;
        this.newServiceCoordinator = item.ServiceCoordinator;
        this.newPrimaryPerson = item.PrimaryPerson;
        this.newInvolvedWitness = item.InvolvedWitness;
        this.newPersonServed = item.PersonServed;
        this.newStaff = item.Staff;
        this.newOther = item.Other;
        this.newPerson2 = item.Person2;
        this.newPersonName2 = item.PersonName2;
        this.newInvolvedWitness2 = item.InvolvedWitness2;
        this.newPersonServed2 = item.PersonServed2;
        this.newStaff2 = item.Staff2;
        this.newOther2 = item.Other2;
        this.newPerson3 = item.Person3;
        this.newPersonName3 = item.PersonName3;
        this.newInvolvedWitness3 = item.InvolvedWitness3;
        this.newPersonServed3 = item.PersonServed3;
        this.newStaff3 = item.Staff3;
        this.newOther3 = item.Other3;
        this.newPerson4 = item.Person4;
        this.newPersonName4 = item.PersonName4;
        this.newInvolvedWitness4 = item.InvolvedWitness4;
        this.newPersonServed4 = item.PersonServed4;
        this.newStaff4 = item.Staff4;
        this.newOther4 = item.Other4;
        this.newPerson5 = item.Person5;
        this.newPersonName5 = item.PersonName5;
        this.newInvolvedWitness5 = item.InvolvedWitness5;
        this.newPersonServed5 = item.PersonServed5;
        this.newStaff5 = item.Staff5;
        this.newOther5 = item.Other5;
        this.newPerson6 = item.Person6;
        this.newPersonName6 = item.PersonName6;
        this.newInvolvedWitness6 = item.InvolvedWitness6;
        this.newPersonServed6 = item.PersonServed6;
        this.newStaff6 = item.Staff6;
        this.newOther6 = item.Other6;
        this.newLiving = item.Living;
        this.newJDT = item.JDT;
        this.newEventDescription = item.EventDescription;
        this.newMissingPersonReport = item.MissingPersonReport;
        this.newInjury = item.Injury;
        this.newInjuryType = item.InjuryType;
        this.newInjuryDetails = item.InjuryDetails;
        this.newInjuryCause = item.InjuryCause;
        this.newInjuryDetails2 = item.InjuryDetails2;
        this.newInjuryPerson = item.InjuryPerson;
        this.newInjuryDetails3 = item.InjuryDetails3;
        this.newNurse = item.Nurse;
        this.newMedicalTreatment = item.MedicalTreatment;
        this.newUnplanned = item.Unplanned;
        this.newHospitalType = item.HospitalType;
        this.newAggression = item.Aggression;
        this.newAggressionType = item.AggressionType;
        this.newAbuseNeglect = item.AbuseNeglect;
        this.newAbuseDescription = item.AbuseDescription;
        this.newVehicleAccident = item.VehicleAccident;
        this.newVehicleType = item.VehicleType;
        this.newMedical = item.Medical;
        this.newMedicalDetails = item.MedicalDetails;
        this.newMedError = item.MedError;
        this.newMedErrorType = item.MedErrorType;
        this.newMedOther = item.MedOther;
        this.newErrorDate = item.ErrorDate;
        this.newErrorTime = item.ErrorTime;
        this.newPhysicianNotified = item.PhysicianNotified;
        this.newEffects = item.Effects;
        this.newNursingDetails = item.NursingDetails;
        this.newStaffName = item.StaffName;
        this.newMedDate = item.MedDate;
        this.newSignatureDate = item.SignatureDate;
        this.newMedDateTime = item.MedDateTime;
        this.newBehavior = item.Behavior;
        this.newPropertyDamage = item.PropertyDamage;
        this.newDamageOther = item.DamageOther;
        this.newPolice = item.Police;
        this.newArrested = item.Arrested;
        this.newDamage = item.Damage;
        this.newVictim = item.Victim;
        this.newVictimOther = item.VictimOther;
        this.newDeath = item.Death;
        this.newDeathType = item.DeathType;
        this.newOtherDescribe = item.OtherDescribe;
        this.newASDS = item.ASDS;
        this.newFamily = item.Family;
        this.newGuardian = item.Guardian;
        this.newServiceCoordinatorName = item.ServiceCoordinatorName;
        this.newPolice911 = item.Police911;
        this.newHealthCareQuality = item.HealthCareQuality;
        this.newAgingServices = item.AgingServices;
        this.newCPS = item.CPS;
        this.newCoroner = item.Coroner;
        this.newShiftSupervisor = item.ShiftSupervisor;
        this.newNurseName = item.NurseName;
        this.newAgencyAdmin = item.AgencyAdmin;
        this.newAgencyOther = item.AgencyOther;
        this.newActionsTaken = item.ActionsTaken;
        this.newReportersName = item.ReportersName;
        this.newReportersSignature = item.ReportersSignature;
        this.newReportersTitle = item.ReportersTitle;
        this.newReportersDate = item.ReportersDate;
        this.newSupervisorSignature = item.SupervisorSignature;
        this.newSupervisorTitle = item.SupervisorTitle;
        this.newSupervisorDate = item.SupervisorDate;
        this.newGuardianNotified = item.GuardianNotified;
        this.newGuardianDate = moment(item.GuardianDate).format("YYYY-MM-DD HH:mm");
        this.newSCNotified = item.SCNotified;
        this.newSCDate = moment(item.SCDate).format("YYYY-MM-DD HH:mm");
        this.newCompliance = item.Compliance;
        this.newComplianceDate = moment(item.ComplianceDate).format("YYYY-MM-DD HH:mm");
        // this.newComplianceDate = moment(item.ComplianceDate).format("YYYY-MM-DD HH:mm");
        this.newComplianceSignature = item.ComplianceSignature;
        this.newWellSkyIR = item.WellSkyIR;
        this.newMedicalType = item.MedicalType;
        this.newJDTOther = item.JDTOther;
        this.newNotificationSubmitted = item.NotificationSubmitted;
        this.newReportSubmitted = item.ReportSubmitted;
        this.reportSubmittedDate = moment(item.ReportSubmittedDate).format("YYYY-MM-DD HH:mm");
        this.newOLReportDate = moment(item.OLReportDate).format("YYYY-MM-DD HH:mm");
        this.newStaffSignature = item.StaffSignature;
        this.staffSignature = item.StaffSigned;
        this.newDocument = item.Documents;
      },

      updateIncident() {
      const payload = {
        RegionalCenter: this.newRegionalCenter,
        Program: this.newProgram,
        ProgramType: this.newProgramType,
        Type: this.newType,
        DSINumber: this.newDSINumber,
        DateReceived: this.newDateReceived,
        DSORNumber: this.newDSORNumber,
        IncidentType: this.newIncidentType,
        IncidentDate: this.newIncidentDate,
        IncidentTime: this.newIncidentTime,
        Provider: this.newProvider,
        ReportDate: this.newReportDate,
        ServiceCoordinator: this.newServiceCoordinator,
        PrimaryPerson: this.newPrimaryPerson,
        InvolvedWitness: this.newInvolvedWitness,
        PersonServed: this.newPersonServed,
        Staff: this.newStaff,
        Other: this.newOther,
        Person2: this.newPerson2,
        PersonName2: this.newPersonName2,
        InvolvedWitness2: this.newInvolvedWitness2,
        PersonServed2: this.newPersonServed2,
        Staff2: this.newStaff2,
        Other2: this.newOther2,
        Person3: this.newPerson3,
        PersonName3: this.newPersonName3,
        InvolvedWitness3: this.newInvolvedWitness3,
        PersonServed3: this.newPersonServed3,
        Staff3: this.newStaff3,
        Other3: this.newOther3,
        Person4: this.newPerson4,
        PersonName4: this.newPersonName4,
        InvolvedWitness4: this.newInvolvedWitness4,
        PersonServed4: this.newPersonServed4,
        Staff4: this.newStaff4,
        Other4: this.newOther4,
        Person5: this.newPerson5,
        PersonName5: this.newPersonName5,
        InvolvedWitness5: this.newInolvedWitness5,
        PersonServed5: this.newPersonServed5,
        Staff5: this.newStaff5,
        Other5: this.newOther5,
        Person6: this.newPerson6,
        PersonName6: this.PersonName6,
        InvolvedWitness6: this.newInvolvedWitness6,
        PersonServed6: this.newPersonServed6,
        Staff6: this.newStaff6,
        Other6: this.newOther6,
        Living: this.newLiving,
        JDT: this.newJDT,
        EventDescription: this.newEventDescription,
        MissingPersonReport: this.newMissingPersonReport,
        Injury: this.newInjury,
        InjuryType: this.newInjuryType,
        InjuryDetails: this.newInjuryDetails,
        InjuryCause: this.newInjuryCause,
        InjuryDetails2: this.newInjuryDetails2,
        InjuryPerson: this.newInjuryPerson,
        InjuryDetails3: this.newInjuryDetails3,
        Nurse: this.newNurse,
        MedicalTreatment: this.newMedicalTreatment,
        Unplanned: this.newUnplanned,
        HospitalType: this.newHospitalType,
        Aggression: this.newAggression,
        AggressionType: this.newAggressionType,
        AbuseNeglect: this.newAbuseNeglect,
        AbuseDescription: this.newAbuseDescription,
        VehicleAccident: this.newVehicleAccident,
        VehicleType: this.newVehicleType,
        Medical: this.newMedical,
        MedicalDetails: this.newMedicalDetails,
        MedError: this.newMedError,
        MedErrorType: this.newMedErrorType,
        MedOther: this.newMedOther,
        ErrorDate: this.newErrorDate,
        ErrorTime: this.newErrorTime,
        PhysicianNotified: this.newPhysicianNotified,
        Effects: this.newEffects,
        NursingDetails: this.newNursingDetails,
        StaffName: this.newStaffName,
        MedDate: this.newMedDate,
        SignatureDate: this.newSignatureDate,
        MedDateTime: this.newMedDateTime,
        Behavior: this.newBehavior,
        PropertyDamage: this.newPropertyDamage,
        DamageOther: this.newDamageOther,
        Police: this.newPolice,
        Arrested: this.newArrested,
        Damage: this.newDamage,
        Victim: this.newVictim,
        VictimOther: this.newVicitmOther,
        Death: this.newDeath,
        DeathType: this.newDeathType,
        OtherDescribe: this.newOtherDescribe,
        ASDS: this.newASDS,
        Family: this.newFamily,
        Guardian: this.newGuardian,
        ServiceCoordinatorName: this.newServiceCoordinatorName,
        Police911: this.newPolice911,
        HealthCareQuality: this.newHealthCareQuality,
        AgingServices: this.newAgingServices,
        CPS: this.newCPS,
        Coroner: this.newCoroner,
        ShiftSupervisor: this.newShiftSupervisor,
        NurseName: this.newNurseName,
        AgencyAdmin: this.newAgencyAdmin,
        AgencyOther: this.newAgencyOther,
        ActionsTaken: this.newActionsTaken,
        ReportersName: this.newReportersName,
        ReportersSignature: this.newReportersSignature,
        ReportersTitle: this.newReportersTitle,
        ReportersDate: this.newReportersDate,
        SupervisorSignature: this.newSupervisorSignature,
        SupervisorTitle: this.newSupervisorTitle,
        SupervisorDate: this.newSupervisorDate,
        GuardianNotified: this.newGuardianNotified,
        GuardianDate: this.newGuardianDate,
        SCNotified: this.newSCNotified,
        SCDate: this.newSCDate,
        Compliance: this.newCompliance,
        ComplianceDate: this.newComplianceDate,
        Documents: this.newDocument,
        ComplianceSignature: this.newComplianceSignature,
        WellSkyIR: this.newWellSkyIR,
        MedicalType: this.newMedicalType,
        JDTOther: this.newJDTOther,
        NotificationSubmitted: this.newNotificationSubmitted,
        ReportSubmitted: this.newReportSubmitted,
        ReportSubmittedDate: this.reportSubmittedDate,
        OLReportDate: this.newOLReportDate,
        StaffSignature: this.newStaffSignature,
        StaffSigned: this.staffSignature
      };

      const updateNvIncidentUrl = `${url}/nevadaIncidents/${this.nvIncidentID}`;

      console.log(this.nvIncidentID)

      axios.put(updateNvIncidentUrl, payload)
          .then(() => {
            if (this.uploadFile !== null && this.uploadFile !== undefined) {
              this.saveFile();
            }


            if (this.damagedPhotos && this.damagedPhotos.length) {
              this.uploadDamagedPhotos(this.damagedPhotos);
            }

            this.incidentQuery();
            this.msg = true;
            this.text="The incident has been updated successfully.";
          });

      this.close();
    },

    fileSelected(e) {
      this.uploadFile=e;
    },

    saveFile() {
      this.message = "";
      if(!Array.isArray(this.uploadFile)){
        this.uploadFile = [this.uploadFile];
      }
      for (let i = 0; i < this.uploadFile.length; i++) {
        this.uploadFiles(this.uploadFile[i]);
      }
    },

    uploadFiles(file) {

      const formData = new FormData();
      formData.append('file', file);
      let ct = { headers:{"content-type" : "multipart/form-data"}};
      axios.post(`${url}/nevadaIncidents/fileUploader/${this.nvIncidentID}`,formData, ct)
          .then(res => {
            if(res){
              this.getIncidents();
            }
          })
          .catch(err => {
            console.log(err);
          });
    },

    clearFields() {
      this.newRegionalCenter = "";
      this.newProgram = "";
      this.newProgramType = "";
      this.newType = "";
      this.newDSINumber = "";
      this.newDateReceived = "";
      this.newDSORNumber = "";
      this.newIncidentType = "";
      this.newIncidentDate = "";
      this.newIncidentTime = "";
      this.newProvider = "";
      this.newReportDate = "";
      this.newServiceCoordinator = "";
      this.newPrimaryPerson = "";
      this.newInvolvedWitness = "";
      this.newPersonServed = "";
      this.newStaff = "";
      this.newOther = "";
      this.newPerson2 = "";
      this.newPersonName2 = "";
      this.newInvolvedWitness2 = "";
      this.newPersonServed2 = "";
      this.newStaff2 = "";
      this.newOther2 = "";
      this.newPerson3 = "";
      this.newPersonName3 = "";
      this.newInvolvedWitness3 = "";
      this.newPersonServed3 = "";
      this.newStaff3 = "";
      this.newOther3 = "";
      this.newPerson4 = "";
      this.newPersonName4 = "";
      this.newInvolvedWitness4 = "";
      this.newPersonServed4 = "";
      this.newStaff4 = "";
      this.newOther4 = "";
      this.newPerson5 = "";
      this.newPersonName5 = "";
      this.newInolvedWitness5 = "";
      this.newPersonServed5 = "";
      this.newStaff5 = "";
      this.newOther5 = "";
      this.newPerson6 = "";
      this.newPersonName6 = "";
      this.newInvolvedWitness6 = "";
      this.newPersonServed6 = "";
      this.newStaff6 = "";
      this.newOther6 = "";
      this.newLiving = "";
      this.newJDT = "";
      this.newEventDescription = "";
      this.newMissingPersonReport = "";
      this.newInjury = "";
      this.newInjuryType = "";
      this.newInjuryDetails = "";
      this.newInjuryCause = "";
      this.newInjuryDetails2 = "";
      this.newInjuryPerson = "";
      this.newInjuryDetails3 = "";
      this.newNurse = "";
      this.newMedicalTreatment = "";
      this.newUnplanned = "";
      this.newHospitalType = "";
      this.newAggression = "";
      this.newAggressionType = "";
      this.newAbuseNeglect = "";
      this.newAbuseDescription = "";
      this.newVehicleAccident = "";
      this.newVehicleType = "";
      this.newMedical = "";
      this.newMedicalDetails = "";
      this.newMedError = "";
      this.newMedErrorType = "";
      this.newMedOther = "";
      this.newErrorDate = "";
      this.newErrorTime = "";
      this.newPhysicianNotified = "";
      this.newEffects = "";
      this.newNursingDetails = "";
      this.newStaffName = "";
      this.newMedDate = "";
      this.newSignatureDate = "";
      this.newMedDateTime = "";
      this.newBehavior = "";
      this.newPropertyDamage = "";
      this.newDamageOther = "";
      this.newPolice = "";
      this.newArrested = "";
      this.newDamage = "";
      this.newVictim = "";
      this.newVicitmOther = "";
      this.newDeath = "";
      this.newDeathType = "";
      this.newOtherDescribe = "";
      this.newASDS = "";
      this.newFamily = "";
      this.newGuardian = "";
      this.newServiceCoordinatorName = "";
      this.newPolice911 = "";
      this.newHealthCareQuality = "";
      this.newAgingServices = "";
      this.newCPS = "";
      this.newCoroner = "";
      this.newShiftSupervisor = "";
      this.newNurseName = "";
      this.newAgencyAdmin = "";
      this.newAgencyOther = "";
      this.newActionsTaken = "";
      this.newReportersName = "";
      this.newReportersSignature = "";
      this.newReportersTitle = "";
      this.newReportersDate = "";
      this.newSupervisorSignaure = "";
      this.newSupervisorTitle = "";
      this.newSupervisorDate = "";
      this.newGuardianNotified = "";
      this.newGuardianDate = "";
      this.newSCNotified = "";
      this.newSCDate = "";
      this.newCompliance = "";
      this.newComplianceDate = "";
      this.newComplianceSignaure = "";
      this.newWellSkyIR = "";
      this.newOLReportDate = "";
      this.newStaffSignature = "";
      this.reportSubmittedDate = "";
      this.newOLReportDate = "";
      this.newNotificationSubmitted = "";
      this.newReportSubmitted = "";
      this.newSupervisorSignature = "";
      this.staffSignature = false;
      this.staffSigned = false;
      this.newDocument = "";
      },

      downloadDocument(){
        window.open(this.newDocument);
      },

      selectIncidentDocument(incidentDocument) {
      this.incidentDocument = incidentDocument;
      },

      printTable() {
        window.print()
    },
    
    }
  }
</script>
<style>
#print {
  display: none
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}



@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }

  @media print { 
    #print{ 
    display: block; 
    border: none; 
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;

    }
    

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none; 

    }

    @page { margin: 0; }
    body { margin: 1.6cm; }
  
    
  } 
</style>